import { Section } from '@pkdigital/pkd-custom-components';
import useMediaQuery from '@restart/hooks/useMediaQuery';
import React from 'react';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { md, sm } from '../../utils/media-queries';
import FullViewHeightSection from '../layout/full-view-height-section';
import { HeroButton } from './HeroButton';
import { HeroImage } from './HeroImage';
import { IphoneMock } from './iphone/IphoneMock';
import SaveInstallationBadgeMobile from '../badge/save-installation/SaveInstallationBadgeMobile';
import { useBranding } from '../../hooks/useBranding';

export default function HeroSection() {
  const isSmOrAbove = useMediaQuery(`(${sm})`);
  const isMdOrAbove = useMediaQuery(`(${md})`);
  const { t } = useTranslation();

  const isHugBranding = useBranding() === 'hug';

  return (
    <>
      <FullViewHeightSection sectionName="hero">
        <Container fluid className="p-0 content">
          {isMdOrAbove && <IphoneMock />}

          {!isMdOrAbove && <SaveInstallationBadgeMobile size={{ width: 155, height: 155 }} />}

          <HeroImage />

          {isSmOrAbove && (
            <Container className={'hero-content'}>
              <h1 className="stage hero-title">
                <>
                  <span>{t(isHugBranding ? 'heroSection.title1-hug' : 'heroSection.title1')}</span>
                  <br />
                  <span>{t(isHugBranding ? 'heroSection.title2-hug' : 'heroSection.title2')}</span>
                </>
              </h1>
              <p className="hero-description mt-2 pb-2 mb-3 pb-2 text-s">
                {t(isHugBranding ? 'heroSection.description1-hug' : 'heroSection.description1')}
                {t(isHugBranding ? 'heroSection.description2-hug' : 'heroSection.description2')}
              </p>
              <HeroButton />
            </Container>
          )}
        </Container>
      </FullViewHeightSection>

      {!isSmOrAbove && (
        <Container className="mobile">
          <Section
            className={'mobile-header'}
            headline={
              <>
                <span>{t(isHugBranding ? 'heroSection.title1-hug' : 'heroSection.title1')}</span>
                <br />
                <span>{t(isHugBranding ? 'heroSection.title2-hug' : 'heroSection.title2')}</span>
              </>
            }
          />
          <p className="description pb-2 mb-3 text-s">
            {t(isHugBranding ? 'heroSection.description1-hug' : 'heroSection.description1')}
            <br /> <br />
            {t(isHugBranding ? 'heroSection.description2-hug' : 'heroSection.description2')}
          </p>

          <HeroButton />
        </Container>
      )}
    </>
  );
}
